import { render, staticRenderFns } from "./KabMimika.vue?vue&type=template&id=5da557f4"
import script from "./KabMimika.vue?vue&type=script&lang=js"
export * from "./KabMimika.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports